import { render, staticRenderFns } from "./LiveDataAll.vue?vue&type=template&id=fa84bc26&scoped=true"
import script from "./LiveDataAll.vue?vue&type=script&lang=js"
export * from "./LiveDataAll.vue?vue&type=script&lang=js"
import style0 from "./LiveDataAll.vue?vue&type=style&index=0&id=fa84bc26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa84bc26",
  null
  
)

export default component.exports